import React, { useState, useRef } from "react";
import * as styles from "../../styles/components/product/feature-tabs.module.css";
import Icon from "../icon";
import { Link } from "gatsby";
import { imageUrlFor } from "../../lib/image-url";
import { buildImageObj } from "../../lib/helpers";

const FeatureTabs = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(0);
  const tabsRef = useRef(null);

  const onMouseDown = (e) => {
    const startX = e.pageX - tabsRef.current.offsetLeft;
    const scrollLeft = tabsRef.current.scrollLeft;

    const onMouseMove = (eMove) => {
      const x = eMove.pageX - tabsRef.current.offsetLeft;
      const walk = (x - startX) * 1.5; // Scroll faster
      tabsRef.current.scrollLeft = scrollLeft - walk;
    };

    const onMouseUpOrLeave = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUpOrLeave);
      document.removeEventListener("mouseleave", onMouseUpOrLeave);
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUpOrLeave);
    document.addEventListener("mouseleave", onMouseUpOrLeave);
  };

  return (
    <div className={styles.root}>
      <div
        className={styles.tabs}
        ref={tabsRef}
        onMouseDown={onMouseDown}
        style={{ cursor: "grab" }} /* Optional: cursor change */
      >
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={index === activeTab ? styles.activeTab : styles.tab}
            onClick={() => setActiveTab(index)}
          >
            <span>{tab.title}</span>
          </button>
        ))}
      </div>
      <div className={styles.content}>
        <div className={styles.titleContainer}>
          {tabs?.[activeTab]?.featureImage && (
            <img
              src={imageUrlFor(buildImageObj(tabs?.[activeTab]?.featureImage))
                .auto("format")
                .url()}
              alt={tabs[activeTab].title}
              className={styles.mainImage}
            />
          )}
          <h3 className="h4">{tabs[activeTab].title}</h3>
        </div>
        <div className={tabs[activeTab]?.featureItems?.length === 1 ? styles.featuresSingle : styles.features}>
          {tabs[activeTab]?.featureItems?.map((feature, index) => {
            const slug =
              feature?.cta?.slug?.__typename === "SanityFeaturePage"
                ? `/product/${feature?.cta?.slug?.correspodingProduct?.slug?.current}/${feature?.cta?.slug?.slug?.current}`
                : `/product/${feature?.cta?.slug?.slug?.current}`;
            return (
              <div key={index} className={tabs[activeTab]?.featureItems?.length === 1 ? styles.featureSingle : styles.feature}>
                {feature.icon && (
                  <img
                    src={imageUrlFor(buildImageObj(feature.icon))
                      .auto("format")
                      .url()}
                    alt={feature.title}
                  />
                )}
                {feature.title && <h3>{feature.title}</h3>}
                <p>{feature.description}</p>
                {feature?.cta && (
                  <Link
                    to={
                      feature?.cta?.type === "internal"
                        ? slug
                        : feature?.cta?.link
                    }
                    className="link"
                  >
                    {feature?.cta?.title}
                    <Icon symbol="arrow-right" />
                  </Link>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FeatureTabs;